import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserNewQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentUserNewQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly companies: ReadonlyArray<{ readonly __typename?: 'AccountsCompany', readonly id: string, readonly name: string }> } | null };

export type GetCurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly roles: ReadonlyArray<Types.AccountsUserRole>, readonly connectedUsers?: ReadonlyArray<{ readonly __typename?: 'AccountsConnectedUser', readonly id: string, readonly uuid: string, readonly email?: string | null, readonly status?: Types.AccountsUsersConnectionStatusType | null, readonly insertedAt: string, readonly profile?: { readonly __typename?: 'AccountsProfile', readonly name?: string | null, readonly position?: string | null } | null, readonly companies: ReadonlyArray<{ readonly __typename?: 'AccountsCompany', readonly id: string }> } | null> | null, readonly restrictions: { readonly __typename?: 'AccountsRestriction', readonly connectedUsersCount?: number | null }, readonly subscription: { readonly __typename?: 'YalperSubscription', readonly isTrial: boolean } } | null };

export type GetCurrentConnectedUserQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetCurrentConnectedUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly companies: ReadonlyArray<{ readonly __typename?: 'AccountsCompany', readonly id: string, readonly name: string }>, readonly connectedUser?: { readonly __typename?: 'AccountsConnectedUser', readonly profile?: { readonly __typename?: 'AccountsProfile', readonly name?: string | null, readonly position?: string | null } | null, readonly companies: ReadonlyArray<{ readonly __typename?: 'AccountsCompany', readonly id: string }> } | null } | null };


export const GetCurrentUserNewDocument = gql`
    query GetCurrentUserNew {
  currentUser {
    companies {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCurrentUserNewQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserNewQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserNewQueryPage, GetCurrentUserNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserNewQueryPage, GetCurrentUserNewQueryVariables>(GetCurrentUserNewDocument, options);
      }
export function useGetCurrentUserNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserNewQueryPage, GetCurrentUserNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserNewQueryPage, GetCurrentUserNewQueryVariables>(GetCurrentUserNewDocument, options);
        }
export function useGetCurrentUserNewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserNewQueryPage, GetCurrentUserNewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserNewQueryPage, GetCurrentUserNewQueryVariables>(GetCurrentUserNewDocument, options);
        }
export type GetCurrentUserNewQueryHookResult = ReturnType<typeof useGetCurrentUserNewQuery>;
export type GetCurrentUserNewLazyQueryHookResult = ReturnType<typeof useGetCurrentUserNewLazyQuery>;
export type GetCurrentUserNewSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserNewSuspenseQuery>;
export type GetCurrentUserNewQueryResult = Apollo.QueryResult<GetCurrentUserNewQueryPage, GetCurrentUserNewQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    roles
    connectedUsers {
      id
      profile {
        name
        position
      }
      uuid
      email
      status
      insertedAt
      companies {
        id
      }
    }
    restrictions {
      connectedUsersCount
    }
    subscription {
      isTrial
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;
export const GetCurrentConnectedUserDocument = gql`
    query GetCurrentConnectedUser($id: ID!) {
  currentUser {
    companies {
      id
      name
    }
    connectedUser(id: $id) {
      profile {
        name
        position
      }
      companies {
        id
      }
    }
  }
}
    `;

/**
 * __useGetCurrentConnectedUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentConnectedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentConnectedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentConnectedUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCurrentConnectedUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentConnectedUserQueryPage, GetCurrentConnectedUserQueryVariables> & ({ variables: GetCurrentConnectedUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentConnectedUserQueryPage, GetCurrentConnectedUserQueryVariables>(GetCurrentConnectedUserDocument, options);
      }
export function useGetCurrentConnectedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentConnectedUserQueryPage, GetCurrentConnectedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentConnectedUserQueryPage, GetCurrentConnectedUserQueryVariables>(GetCurrentConnectedUserDocument, options);
        }
export function useGetCurrentConnectedUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentConnectedUserQueryPage, GetCurrentConnectedUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentConnectedUserQueryPage, GetCurrentConnectedUserQueryVariables>(GetCurrentConnectedUserDocument, options);
        }
export type GetCurrentConnectedUserQueryHookResult = ReturnType<typeof useGetCurrentConnectedUserQuery>;
export type GetCurrentConnectedUserLazyQueryHookResult = ReturnType<typeof useGetCurrentConnectedUserLazyQuery>;
export type GetCurrentConnectedUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentConnectedUserSuspenseQuery>;
export type GetCurrentConnectedUserQueryResult = Apollo.QueryResult<GetCurrentConnectedUserQueryPage, GetCurrentConnectedUserQueryVariables>;